$(document).ready(function (){
   // gsap.utils.toArray(".abre").forEach((panel, i) => { console.log(i);
   //    let trigger = ScrollTrigger.create({
   //       trigger: panel,
   //       start: "top top",
   //      // pin: i === 12 ? false: true,
   //       pin: true,
   //       pinSpacing: false
   //    });
   // });

   $('.sl a').on('click', function (e){
      e.preventDefault();

      var img = $(this).data('img');
      var align = $(this).data('align');
      var $modal = $('#saibaModal');

      $modal.removeClass('h');
      $modal.removeClass('v');
      $modal.addClass(align);
      $modal.find('.img-content').attr('src', img);

      $modal.modal('show');
   })

   $('.slide .titulo').on('click',function (e){
      e.preventDefault();

      var $slide = $(this).closest('.slide');

      $(this).closest('.accordeon').find('.slide').removeClass('slide--expanded');
      $(this).closest('.accordeon').find('.conteudo').hide();
      $slide.addClass('slide--expanded');

      setTimeout(function () { console.log(':D');
         $slide.find('.conteudo').fadeIn();
      }, 400);
   });

   const slider = tns({
      container: '.slider-img',
      mouseDrag: true,
      nav: false,
      loop: false,
      controlsContainer : '.slider-img-control',
      responsive: {
         350: {
            items: 1,
            gutter: 0,
         },
         500: {
            items: 3,
            gutter: 50,
         }
      }
   });
});